// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — styledComponents.classic.js, новая — styledComponents.cp.js
import { isCp } from 'libs/design';
import * as classic from './styledComponents.classic';
import * as cp from './styledComponents.cp';

export const Block = isCp ? cp.Block : classic.Block;
export const ControlPanel = isCp ? cp.ControlPanel : classic.ControlPanel;
export const ControllWrapper = isCp ? cp.ControllWrapper : classic.ControllWrapper;
export const Media = isCp ? cp.Media : classic.Media;
export const Notification = isCp ? cp.Notification : classic.Notification;
export const RackWrapper = isCp ? cp.RackWrapper : classic.RackWrapper;
export const Table = isCp ? cp.Table : classic.Table;
export const Table2 = isCp ? cp.Table2 : classic.Table2;
export const WarningNotification = isCp ? cp.WarningNotification : classic.WarningNotification;
